export default "__VITE_ASSET__Bqao$jcb__"